// 组件入口配置信息文件

// 组件文档信息
const componentDocs = [
  {
    "comName": "Container",
    "displayName": "详情容器",
    "path": "/demo/detail-container",
    "exampleName": "detail-container.tsx",
    "category": "Data"
  },
  {
    "comName": "PartTitle",
    "displayName": "详情标题",
    "path": "/demo/detail-part-title",
    "exampleName": "detail-part-title.tsx",
    "category": "Detail"
  },
  {
    "comName": "Empty",
    "displayName": "空状态",
    "path": "/demo/empty-index",
    "exampleName": "empty-index.tsx",
    "category": "Basic"
  },
  {
    "comName": "WechatIcon",
    "displayName": "企业微信icon组件",
    "path": "/demo/icon-font-wechat-icon",
    "exampleName": "icon-font-wechat-icon.tsx",
    "category": "Basic"
  },
  {
    "comName": "Iframe",
    "displayName": "Iframe",
    "path": "/demo/iframe-index",
    "exampleName": "iframe-index.tsx",
    "category": "Basic"
  },
  {
    "comName": "LazyLoad",
    "displayName": "懒加载",
    "path": "/demo/lazy-load-index",
    "exampleName": "lazy-load-index.tsx",
    "category": "Basic"
  },
  {
    "comName": "ConfirmModal",
    "displayName": "二次确认弹窗",
    "path": "/demo/modal-confirm-modal",
    "exampleName": "modal-confirm-modal.tsx",
    "category": "Notice"
  },
  {
    "comName": "Operate",
    "displayName": "按钮组组件",
    "path": "/demo/operate-index",
    "exampleName": "operate-index.tsx",
    "category": "Basic"
  },
  {
    "comName": "ScreenShot",
    "displayName": "截图绘制",
    "path": "/demo/screen-shot-index",
    "exampleName": "screen-shot-index.tsx",
    "category": "Basic"
  },
  {
    "comName": "TagGroup",
    "displayName": "标签组",
    "path": "/demo/tag-group-index",
    "exampleName": "tag-group-index.tsx",
    "category": "Data"
  },
  {
    "comName": "ColorText",
    "displayName": "颜色图标文本",
    "path": "/demo/text-color-text",
    "exampleName": "text-color-text.tsx",
    "category": "Text"
  },
  {
    "comName": "CopyTextIcon",
    "displayName": "复制文本图标",
    "path": "/demo/text-copy-text-icon",
    "exampleName": "text-copy-text-icon.tsx",
    "category": "Text"
  },
  {
    "comName": null,
    "displayName": "主页",
    "path": "/demo/index",
    "exampleName": "custom-doc/index/entry.tsx",
    "category": "Introduce"
  },
  {
    "comName": null,
    "displayName": "地图",
    "path": "/demo/amap",
    "exampleName": "custom-doc/map/entry.tsx",
    "category": "Introduce"
  },
  {
    "comName": null,
    "displayName": "Html 转 Canvas",
    "path": "/demo/html2canvas",
    "exampleName": "custom-doc/html2canvas/entry.tsx",
    "category": "Introduce"
  },
  {
    "comName": null,
    "displayName": "开发简介",
    "path": "/demo/introduce",
    "exampleName": "custom-doc/introduce/entry.tsx",
    "category": "Introduce"
  },
  {
    "comName": null,
    "displayName": "字段匹配",
    "path": "/demo/field-matching",
    "exampleName": "custom-doc/field-matching/entry.tsx",
    "category": "Introduce"
  },
  {
    "comName": null,
    "displayName": "列表拖拽",
    "path": "/demo/table-drag",
    "exampleName": "custom-doc/table-drag/entry.tsx",
    "category": "Introduce"
  },
  {
    "comName": null,
    "displayName": "Form 组件合集",
    "path": "/demo/form-collection",
    "exampleName": "custom-doc/form-collection/entry.tsx",
    "category": "Form"
  },
  {
    "comName": null,
    "displayName": "DynamicComponent 动态组件",
    "path": "/demo/dynamic-component",
    "exampleName": "custom-doc/dynamic-component/entry.tsx",
    "category": "Form"
  },
  {
    "comName": null,
    "displayName": "Preview 业务预览（审批、合同、企业等）",
    "path": "/demo/preview",
    "exampleName": "custom-doc/preview/entry.tsx",
    "category": "Text"
  }
];

// 组件路由信息
const routes = [
  {
    "path": "/demo/detail-container",
    "meta": {
      "name": "demo-详情容器",
      "title": "Container 详情容器",
      "isComponentDoc": true,
      "category": "Data",
      "seq": "5.0"
    }
  },
  {
    "path": "/demo/detail-part-title",
    "meta": {
      "name": "demo-详情标题",
      "title": "PartTitle 详情标题",
      "isComponentDoc": true,
      "category": "Detail",
      "seq": "4.1"
    }
  },
  {
    "path": "/demo/empty-index",
    "meta": {
      "name": "demo-空状态",
      "title": "Empty 空状态",
      "isComponentDoc": true,
      "category": "Basic",
      "seq": "3.2"
    }
  },
  {
    "path": "/demo/icon-font-wechat-icon",
    "meta": {
      "name": "demo-企业微信icon组件",
      "title": "WechatIcon 企业微信icon组件",
      "isComponentDoc": true,
      "category": "Basic",
      "seq": "3.3"
    }
  },
  {
    "path": "/demo/iframe-index",
    "meta": {
      "name": "demo-Iframe",
      "title": "Iframe Iframe",
      "isComponentDoc": true,
      "category": "Basic",
      "seq": "3.4"
    }
  },
  {
    "path": "/demo/lazy-load-index",
    "meta": {
      "name": "demo-懒加载",
      "title": "LazyLoad 懒加载",
      "isComponentDoc": true,
      "category": "Basic",
      "seq": "3.5"
    }
  },
  {
    "path": "/demo/modal-confirm-modal",
    "meta": {
      "name": "demo-二次确认弹窗",
      "title": "ConfirmModal 二次确认弹窗",
      "isComponentDoc": true,
      "category": "Notice",
      "seq": "9.6"
    }
  },
  {
    "path": "/demo/operate-index",
    "meta": {
      "name": "demo-按钮组组件",
      "title": "Operate 按钮组组件",
      "isComponentDoc": true,
      "category": "Basic",
      "seq": "3.7"
    }
  },
  {
    "path": "/demo/screen-shot-index",
    "meta": {
      "name": "demo-截图绘制",
      "title": "ScreenShot 截图绘制",
      "isComponentDoc": true,
      "category": "Basic",
      "seq": "3.8"
    }
  },
  {
    "path": "/demo/tag-group-index",
    "meta": {
      "name": "demo-标签组",
      "title": "TagGroup 标签组",
      "isComponentDoc": true,
      "category": "Data",
      "seq": "5.9"
    }
  },
  {
    "path": "/demo/text-color-text",
    "meta": {
      "name": "demo-颜色图标文本",
      "title": "ColorText 颜色图标文本",
      "isComponentDoc": true,
      "category": "Text",
      "seq": "7.10"
    }
  },
  {
    "path": "/demo/text-copy-text-icon",
    "meta": {
      "name": "demo-复制文本图标",
      "title": "CopyTextIcon 复制文本图标",
      "isComponentDoc": true,
      "category": "Text",
      "seq": "7.11"
    }
  },
  {
    "path": "/demo/index",
    "meta": {
      "name": "demo-主页",
      "title": "主页",
      "isComponentDoc": true,
      "category": "Introduce",
      "seq": "1.12"
    }
  },
  {
    "path": "/demo/amap",
    "meta": {
      "name": "demo-地图",
      "title": "地图",
      "isComponentDoc": true,
      "category": "Introduce",
      "seq": "1.13"
    }
  },
  {
    "path": "/demo/html2canvas",
    "meta": {
      "name": "demo-Html 转 Canvas",
      "title": "Html 转 Canvas",
      "isComponentDoc": true,
      "category": "Introduce",
      "seq": "1.14"
    }
  },
  {
    "path": "/demo/introduce",
    "meta": {
      "name": "demo-开发简介",
      "title": "开发简介",
      "isComponentDoc": true,
      "category": "Introduce",
      "seq": "1.15"
    }
  },
  {
    "path": "/demo/field-matching",
    "meta": {
      "name": "demo-字段匹配",
      "title": "字段匹配",
      "isComponentDoc": true,
      "category": "Introduce",
      "seq": "1.16"
    }
  },
  {
    "path": "/demo/table-drag",
    "meta": {
      "name": "demo-列表拖拽",
      "title": "列表拖拽",
      "isComponentDoc": true,
      "category": "Introduce",
      "seq": "1.17"
    }
  },
  {
    "path": "/demo/form-collection",
    "meta": {
      "name": "demo-Form 组件合集",
      "title": "Form 组件合集",
      "isComponentDoc": true,
      "category": "Form",
      "seq": "12.18"
    }
  },
  {
    "path": "/demo/dynamic-component",
    "meta": {
      "name": "demo-DynamicComponent 动态组件",
      "title": "DynamicComponent 动态组件",
      "isComponentDoc": true,
      "category": "Form",
      "seq": "12.19"
    }
  },
  {
    "path": "/demo/preview",
    "meta": {
      "name": "demo-Preview 业务预览（审批、合同、企业等）",
      "title": "Preview 业务预览（审批、合同、企业等）",
      "isComponentDoc": true,
      "category": "Text",
      "seq": "7.20"
    }
  }
];

// 组件文档导航信息
const componentDocsMenu = [
  {
    "name": "Introduce",
    "path": "/demo-category/introduce",
    "children": [
      {
        "name": "主页",
        "path": "/demo/index",
        "category": "Introduce",
        "seq": "1.12"
      },
      {
        "name": "地图",
        "path": "/demo/amap",
        "category": "Introduce",
        "seq": "1.13"
      },
      {
        "name": "Html 转 Canvas",
        "path": "/demo/html2canvas",
        "category": "Introduce",
        "seq": "1.14"
      },
      {
        "name": "开发简介",
        "path": "/demo/introduce",
        "category": "Introduce",
        "seq": "1.15"
      },
      {
        "name": "字段匹配",
        "path": "/demo/field-matching",
        "category": "Introduce",
        "seq": "1.16"
      },
      {
        "name": "列表拖拽",
        "path": "/demo/table-drag",
        "category": "Introduce",
        "seq": "1.17"
      }
    ],
    "seq": 1
  },
  {
    "name": "Basic",
    "path": "/demo-category/basic",
    "children": [
      {
        "name": "Empty 空状态",
        "path": "/demo/empty-index",
        "category": "Basic",
        "seq": "3.2"
      },
      {
        "name": "WechatIcon 企业微信icon组件",
        "path": "/demo/icon-font-wechat-icon",
        "category": "Basic",
        "seq": "3.3"
      },
      {
        "name": "Iframe Iframe",
        "path": "/demo/iframe-index",
        "category": "Basic",
        "seq": "3.4"
      },
      {
        "name": "LazyLoad 懒加载",
        "path": "/demo/lazy-load-index",
        "category": "Basic",
        "seq": "3.5"
      },
      {
        "name": "Operate 按钮组组件",
        "path": "/demo/operate-index",
        "category": "Basic",
        "seq": "3.7"
      },
      {
        "name": "ScreenShot 截图绘制",
        "path": "/demo/screen-shot-index",
        "category": "Basic",
        "seq": "3.8"
      }
    ],
    "seq": 3
  },
  {
    "name": "Detail",
    "path": "/demo-category/detail",
    "children": [
      {
        "name": "PartTitle 详情标题",
        "path": "/demo/detail-part-title",
        "category": "Detail",
        "seq": "4.1"
      }
    ],
    "seq": 4
  },
  {
    "name": "Data",
    "path": "/demo-category/data",
    "children": [
      {
        "name": "Container 详情容器",
        "path": "/demo/detail-container",
        "category": "Data",
        "seq": "5.0"
      },
      {
        "name": "TagGroup 标签组",
        "path": "/demo/tag-group-index",
        "category": "Data",
        "seq": "5.9"
      }
    ],
    "seq": 5
  },
  {
    "name": "Text",
    "path": "/demo-category/text",
    "children": [
      {
        "name": "ColorText 颜色图标文本",
        "path": "/demo/text-color-text",
        "category": "Text",
        "seq": "7.10"
      },
      {
        "name": "CopyTextIcon 复制文本图标",
        "path": "/demo/text-copy-text-icon",
        "category": "Text",
        "seq": "7.11"
      },
      {
        "name": "Preview 业务预览（审批、合同、企业等）",
        "path": "/demo/preview",
        "category": "Text",
        "seq": "7.20"
      }
    ],
    "seq": 7
  },
  {
    "name": "Notice",
    "path": "/demo-category/notice",
    "children": [
      {
        "name": "ConfirmModal 二次确认弹窗",
        "path": "/demo/modal-confirm-modal",
        "category": "Notice",
        "seq": "9.6"
      }
    ],
    "seq": 9
  },
  {
    "name": "Form",
    "path": "/demo-category/form",
    "children": [
      {
        "name": "Form 组件合集",
        "path": "/demo/form-collection",
        "category": "Form",
        "seq": "12.18"
      },
      {
        "name": "DynamicComponent 动态组件",
        "path": "/demo/dynamic-component",
        "category": "Form",
        "seq": "12.19"
      }
    ],
    "seq": 12
  }
];

export { componentDocs, routes, componentDocsMenu };